import { gql } from '@apollo/client';

// 地址分析响应类型定义
export interface EntityComponent {
    addressLine1: string;
    cityName?: string | null;
    stateAbbreviation?: string | null;
    zipcode?: string | null;
}

export interface ParsedAddressType {
    entityComponents: EntityComponent;
}

export interface AnalyzeAddressSimpleResponse {
    analyzeAddressSimple: ParsedAddressType | null;
}

// GraphQL查询定义
export const ANALYZE_ADDRESS_SIMPLE = gql`
    query AnalyzeAddressSimple(
        $streetAddress: String!
        $unit: String
        $city: String!
        $state: String!
        $zipCode: String!
    ) {
        analyzeAddressSimple(
            streetAddress: $streetAddress
            unit: $unit
            city: $city
            state: $state
            zipCode: $zipCode
        ) {
            entityComponents {
                addressLine1
                cityName
                stateAbbreviation
                zipcode
            }
        }
    }
`;

